import { DestroyBase } from "../ng-destroy-base";
import { TabConfig } from "../pollux-tab-config/pollux-form-config";

/**
 * Standardized infobar host base class.
 */
export abstract class InfobarBase extends DestroyBase {
  /**
   * Handles element selection form a grid
   * @param tabItem The tab
   * @param item The selected item
   */
  public abstract onElementSelected(tabItem: TabConfig, item: any);
}
